module.exports = __webpack_public_path__ + "static/media/SILKSERIF-BOLD.0fe2ef51.woff";